/** The characters an operator-chosen identifier is made of, whole. */
export const ID_RE = /^[A-Za-z0-9._:-]+$/;
/** The longest an operator-chosen identifier is, unless a caller says less. */
export const ID_MAX_LENGTH = 64;
/**
 * An operator-chosen identifier: non-empty, bounded, and safe in a URL path and
 * a foreign key. Trimmed, because a trailing space is invisible in the box it
 * was typed into.
 *
 * HERE rather than in the worker so the panel can tell the operator which box
 * is wrong BEFORE asking -- by running the same function, not a copy of its
 * regex. `worker/src/lib/validate.ts` re-exports it for the worker.
 */
export function asId(value, maxLength = ID_MAX_LENGTH) {
    if (typeof value !== "string")
        return null;
    const v = value.trim();
    if (v.length === 0 || v.length > maxLength)
        return null;
    return ID_RE.test(v) ? v : null;
}
//# sourceMappingURL=ids.js.map